<template>
  <div class="exam">
    <div class="exam-info">
      <p class="text-paragraph">考试剩余时间：</p>
      <p class="exam-timer" :class="{
        'text-orange': examInfo && leftTime <= NOTICE_TIME && leftTime > WILL_FINISH,
        'text-red': examInfo && leftTime <= WILL_FINISH
      }">{{ leftMinutes }} : {{ leftSeconds }}</p>
      <p class="exam-record"><i class="exam-record-icon"></i> 正在进行音视频实时监控...</p>
    </div>

    <Button type="primary" long @click="handlePaperSubmit(true)">立即交卷</Button>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
import { USER, EXAMINATION } from '../../../libs/namespace'
import { sleep } from '../../../libs/util'
import { COURSE_STATUS, COUNTER_TIMER } from '../../../libs/constant'

const NOTICE_TIME = 15 * 60 // 15分钟倒计时提醒
const WILL_FINISH = 5 * 60 // 5分钟倒计时提醒

export default {
  data () {
    return {
      NOTICE_TIME,
      WILL_FINISH,
      courseId: this.$route.params.courseId,
      examInfo: null,
      leftTime: 0,
      interval: void 0
    }
  },
  computed: {
    leftMinutes () {
      return parseInt(this.leftTime / 60)
    },
    leftSeconds () {
      const seconds = this.leftTime % 60
      return seconds < 10 ? ('0' + seconds) : seconds
    }
  },
  created () {
    // window.hideLoading(true)
    // this.showResultDialog({
    //   userScore: 50,
    //   passed: true,
    //   certificationId: '123456'
    // })
    this.initExam()
  },
  destroyed () {
    clearInterval(this.interval)
  },
  handlers: {
    // 交卷操作
    async handlePaperSubmit (showConfirm) {
      if (showConfirm) {
        const flag = await window.confirm({
          title: '是否确认交卷？'
        })
        if (!flag) return
      }
      clearInterval(this.interval)
      this.submitPaper()
    }
  },
  methods: {
    ...mapMutations([ 'setTitle' ]),
    ...mapMutations(EXAMINATION, [ 'setPaper' ]),
    ...mapActions(USER, [ 'checkStatus' ]),
    ...mapActions(EXAMINATION, [ 'fetchExamInfo', 'createPaper', 'submitAnswers' ]),

    async initExam () {
      window.showLoading('正在开启音视频录制，请勿退出或刷新...')
      await sleep(2)
      window.showLoading('正在获取考试内容，请勿退出或刷新...')
      await this.getExamInfo()
      await this.getPaperInfo()
      await sleep(2)
      let timer = COUNTER_TIMER
      const interval = setInterval(() => {
        if (!timer) {
          window.hideLoading(true)
          window.toast.info('考试开始')
          this.timerStart()
          clearInterval(interval)
          return
        }
        window.showLoading(`试卷准备完成，将在 ${timer} 秒后开始考试`)
        timer--
      }, 1000)
    },

    async getExamInfo () {
      const data = await this.fetchExamInfo(this.courseId)
      if (data.exam.status !== COURSE_STATUS.NO_EXAM) {
        window.hideLoading(true)
        await window.alert({
          type: 'error',
          title: '您已经参加过该考试',
          content: '<p class="text-paragraph text-index">您已经参加过该考试，请勿重复参考。</p><p class="text-paragraph text-index">如果您已通过该考试，可在考试大厅查看证书；如您未通过考试，请先缴纳补考费后通过考试大厅进行补考！</p>'
        })
        this.$router.replace({ name: 'index' })
        throw new Error('您已经参加过该考试')
      }
      this.setTitle({ title: data.exam.name })
      this.examInfo = data.exam
      this.leftTime = data.exam.timeLimit * 60
    },

    async getPaperInfo () {
      const { data, status, msg } = await this.createPaper(this.courseId)
      if (status !== 10000) {
        window.hideLoading(true)
        await window.alert({
          type: 'error',
          title: '考试提示',
          content: msg
        })
        this.$router.replace({ name: 'index' })
        throw new Error(msg)
      }
      this.setPaper(data)
    },

    async checkLoginStatus () {
      const { status } = await this.checkStatus(true)
      if (status !== 10000) {
        clearInterval(this.interval)
        await window.alert({
          type: 'error',
          title: '您可能存在作弊行为！',
          content: '检测到您当前登录了微信端应用，即将终止此次考试，成绩作0分处理，如有疑问请阅读参考须知。'
        })
        window.localStorage.clear()
        window.location.reload()
      }
    },

    async timerStart () {
      this.interval = setInterval(() => {
        if (!this.leftTime) {
          this.$Modal.remove()
          this.handlePaperSubmit()
          return
        }
        this.leftTime--
        if (this.leftTime % 10 === 0) {
          this.checkLoginStatus()
        }
        if (this.leftTime === NOTICE_TIME) {
          this.$Notice.info({
            title: '距离考试结束还有15分钟'
          })
        }
        if (this.leftTime === WILL_FINISH) {
          this.$Notice.info({
            title: '距离考试结束还有5分钟'
          })
        }
      }, 1000)
    },

    async submitPaper () {
      window.showLoading('考试结束，正在交卷请稍候...')
      await sleep(5)
      try {
        const res = await this.submitAnswers()
        this.showResultDialog(res)
      } catch (error) {
        //
      } finally {
        window.hideLoading(true)
      }
    },

    async showResultDialog ({ userScore, passed, courseId }) {
      if (!passed) {
        await window.alert({
          type: 'error',
          okText: '回到考试大厅',
          title: '考试未通过',
          content: `
            <p class="text-paragraph">您本场考试的得分为 <span class="text-bold">${ userScore } 分</span>，考试未通过。</p>
            <p class="text-paragraph">如您需要补考，请前往微信端应用相应课程的考试中心进行补考缴费。</p>
          `
        })
        this.$router.back()
      } else {
        await window.alert({
          type: 'success',
          okText: '查看我的证书',
          title: '考试通过',
          content: `
            <p class="text-paragraph">您本场考试的得分为 <span class="text-bold">${ userScore } 分</span>，考试已通过，可点击下放按钮可查看您获得的证书。</p>
            <p class="text-paragraph text-bold">如您需要换取相应的国家认证证书，可在查看证书页面进行操作。</p>
          `
        })
        this.$router.replace({
          name: 'certification',
          params: {
            courseId
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.exam {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;

  &-info {
    margin-top: 40px;
  }
  &-timer {
    font-size: 40px;
    font-weight: bolder;
    text-align: center;
  }
  &-record {
    display: flex;
    margin-top: 40px;
    justify-content: center;
    align-items: center;

    &-icon {
      flex: none;
      display: block;
      position: relative;
      width: 30px;
      height: 30px;
      margin-right: 10px;
      border: 2px solid #ed4014;
      border-radius: 50%;
      &:before {
        content: "";
        display: block;
        position: absolute;
        width: 10px;
        height: 10px;
        left: 50%;
        top: 50%;
        border-radius: 50%;
        opacity: 1;
        background: #ed4014;
        transform: translate(-50%, -50%);
        animation: record-loading 2s linear infinite;
      }
    }
  }
}

@keyframes record-loading {
  from { width: 10px; height: 10px; opacity: 1; }
  50%  { width: 15px; height: 15px; opacity: .7; }
  to   { width: 10px; height: 10px; opacity: 1; }
}
</style>
